import React from "react";
import { ReactComponent as IconForward } from "../../assets/icons/icon_forward.svg";
import { ReactComponent as IconFront } from "../../assets/icons/icon_to_front.svg";
import { ReactComponent as IconBackward } from "../../assets/icons/icon_backward.svg";
import { ReactComponent as IconBack } from "../../assets/icons/icon_to_back.svg";
import { ReactComponent as IconFlipH } from "../../assets/icons/icon_flip_h.svg";
import { ReactComponent as IconFlipV } from "../../assets/icons/icon_flip_v.svg";
import { ReactComponent as IconBottom } from "../../assets/icons/align-bottom.svg";
import { ReactComponent as IconMiddle } from "../../assets/icons/align-middle.svg";
import { ReactComponent as IconLeft } from "../../assets/icons/align-left.svg";
import { ReactComponent as IconRight } from "../../assets/icons/align-right.svg";
import { ReactComponent as IconTop } from "../../assets/icons/align-top.svg";
import { ReactComponent as IconCenter } from "../../assets/icons/align-center.svg";
import { takeSnapshopAndCreateTemplate } from "../../_actions/storiesActions";
import {
  ALIGN_LEFT,
  ALIGN_MIDDLE,
  ALIGN_RIGHT,
  ALIGN_TOP,
  ALIGN_CENTER,
  ALIGN_BOTTOM,
  FLIPH,
  FLIPV,
} from "../details/constants";
import {
  alignObject,
  checkArtboardLimit,
  onSetAsBackgroundRenderArtboard,
} from "../../_utils/common";
import { StyledContextMenuDivider } from "../styled/details/stylesDetails";
import {
  FaChevronRight,
  FaExpandArrowsAlt,
  FaPlus,
  FaShapes,
} from "react-icons/fa";
import {
  Button,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const menuStyles = {
  px: 20,
  py: 8,
  background: "var(--chakra-colors-gray-500)",
  fontSize: 14,
  color: "white",
  border: "none",
  width: "100%",
  textAlign: "left",
  svg: {
    height: 15,
    width: 15,
  },
  _hover: {
    bg: "var(--chakra-colors-primary-400)",
  },
  _disabled: {
    color: "var(--chakra-colors-gray-300)",
  },
};

const menuStylesList = {
  pl: 20,
  pr: 60,
  py: 8,
  background: "var(--chakra-colors-gray-500)",
  fontSize: 14,
  color: "white",
  border: "none",
  width: "100%",
  textAlign: "left",
  mr: "2px",
  svg: {
    height: 15,
    width: 15,
  },
  _hover: {
    bg: "var(--chakra-colors-primary-400)",
  },
  _disabled: {
    color: "var(--chakra-colors-gray-300)",
  },
};

const menuBtnStyles = {
  px: 20,
  py: 8,
  background: "var(--chakra-colors-gray-500)",
  fontSize: 14,
  color: "white",
  border: "none",
  width: "100%",
  textAlign: "left",
  svg: {
    height: 15,
    width: 15,
  },
  _hover: {
    bg: "var(--chakra-colors-primary-400)",
  },
  _disabled: {
    color: "var(--chakra-colors-gray-300)",
  },
};

const onClick = async (action, props) => {
  if (action === "add_new_slide") {
    const { pagestore, subscription } = props.parentProps;
    const isAvailable = checkArtboardLimit(pagestore, subscription);
    if (isAvailable) props.parentProps.wsAddPage();
  } else if (action === "set_as_background") {
    const {
      editor: {
        activeElement: { id: activeElementId } = {},
        activePage: { id: activePageId } = {},
      },
      wsSetAsBackground,
    } = props.parentProps;
    await onSetAsBackgroundRenderArtboard(props.canvasRef);
    wsSetAsBackground(activePageId, activeElementId);
  } else if (action.startsWith("move")) {
    props.canvasRef.handler.move(action);
    props.parentProps.wsMoveLayer(
      action,
      props.parentProps.editor.activeElement.id
    );
  } else if (action === "save_as_component") {
    takeSnapshopAndCreateTemplate(
      "component",
      { canvasRef: props.canvasRef, props: props.parentProps },
      props.signal
    );
  }

  if (props.canvasRef) {
    props.canvasRef.handler.contextmenuHandler.hide();
  }
};

const transform = (action, props) => {
  const { editor } = props.parentProps;
  let editorFormat = editor.activeElement.format;
  switch (action) {
    case FLIPH:
      props.canvasRef.handler.objectHandler.flipX(!editorFormat?.flipX);
      break;
    case FLIPV:
      props.canvasRef.handler.objectHandler.flipY(!editorFormat?.flipY);
      break;
    default:
      return;
  }
};

const PageMenu = (props) => {
  const { t } = useTranslation(["studio"]);
  return (
    <Menu isLazy>
      <MenuButton
        sx={menuStyles}
        onClick={() => onClick("add_new_slide", props)}
        leftIcon={<FaPlus />}
        as={Button}
      >
        {t("context_menu.new_slide")}
      </MenuButton>
    </Menu>
  );
};

const LayerMenu = (props) => {
  const { t } = useTranslation(["studio"]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenFlip,
    onOpen: onOpenFlip,
    onClose: onCloseFlip,
  } = useDisclosure();
  const { target, parentProps } = props;
  const { editor, layerstore, pagestore } = parentProps;
  const activePageId = editor.activePage.id;
  const activeElementId = editor.activeElement.id;
  if (!activePageId || !activeElementId) {
    return <></>;
  }
  let totalLayersInPage = pagestore.pages[activePageId]?.layers.length - 1;
  let selectedLayer = layerstore.layers[activeElementId];

  return (
    <Menu isLazy>
      {target.type === "image" && (
        <>
          <MenuItem
            onClick={() => onClick("set_as_background", props)}
            icon={<FaExpandArrowsAlt />}
            sx={menuStyles}
          >
            {t("context_menu.set_as_bg")}
          </MenuItem>

          <StyledContextMenuDivider />
        </>
      )}
      {selectedLayer && (
        <>
          <MenuItem
            isDisabled={selectedLayer.order === totalLayersInPage}
            icon={<IconFront fill="white" />}
            onClick={() => onClick("move_to_front", props)}
            sx={menuStyles}
          >
            {t("context_menu.bring_front")}
          </MenuItem>
          <MenuItem
            isDisabled={selectedLayer.order === totalLayersInPage}
            icon={<IconForward fill="white" />}
            onClick={() => onClick("move_forward", props)}
            sx={menuStyles}
          >
            {t("context_menu.brind_forward")}
          </MenuItem>
          <MenuItem
            isDisabled={selectedLayer.order === 0}
            icon={<IconBack fill="white" />}
            onClick={() => onClick("move_backward", props)}
            sx={menuStyles}
          >
            {t("context_menu.send_backward")}
          </MenuItem>
          <MenuItem
            isDisabled={selectedLayer.order === 0}
            onClick={() => onClick("move_to_back", props)}
            sx={menuStyles}
            icon={<IconBackward fill="white" />}
          >
            {t("context_menu.send_back")}
          </MenuItem>
        </>
      )}
      <MenuItem
        icon={<FaShapes />}
        onClick={() => onClick("save_as_component", props)}
        sx={menuStyles}
      >
        {t("context_menu.save_comp")}
      </MenuItem>
      <StyledContextMenuDivider />
      <MenuGroup>
        <Menu isLazy placement="right-start" isOpen={isOpen} onClose={onClose}>
          <MenuButton
            sx={menuBtnStyles}
            onMouseEnter={onOpen}
            onMouseLeave={onClose}
            rightIcon={<FaChevronRight size={10} />}
            as={Button}
          >
            {t("context_menu.align")}
          </MenuButton>
          <MenuList onMouseEnter={onOpen} onMouseLeave={onClose} mx={-5}>
            <MenuItem
              onClick={() => alignObject(ALIGN_TOP, props.canvasRef)}
              icon={<IconTop fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.top")}
            </MenuItem>
            <MenuItem
              onClick={() => alignObject(ALIGN_MIDDLE, props.canvasRef)}
              icon={<IconMiddle fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.middle")}
            </MenuItem>
            <MenuItem
              onClick={() => alignObject(ALIGN_BOTTOM, props.canvasRef)}
              icon={<IconBottom fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.bottom")}
            </MenuItem>
            <MenuItem
              onClick={() => alignObject(ALIGN_LEFT, props.canvasRef)}
              icon={<IconLeft fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.left")}
            </MenuItem>
            <MenuItem
              onClick={() => alignObject(ALIGN_CENTER, props.canvasRef)}
              icon={<IconCenter fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.center")}
            </MenuItem>
            <MenuItem
              onClick={() => alignObject(ALIGN_RIGHT, props.canvasRef)}
              icon={<IconRight fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.right")}
            </MenuItem>
          </MenuList>
        </Menu>
      </MenuGroup>
      <MenuGroup>
        <Menu placement="right-start" isOpen={isOpenFlip} onClose={onCloseFlip}>
          <MenuButton
            sx={menuBtnStyles}
            onMouseEnter={onOpenFlip}
            onMouseLeave={onCloseFlip}
            rightIcon={<FaChevronRight size={10} />}
            as={Button}
          >
            {t("context_menu.flip")}
          </MenuButton>
          <MenuList
            onMouseEnter={onOpenFlip}
            onMouseLeave={onCloseFlip}
            mx={-5}
          >
            <MenuItem
              onClick={() => transform(FLIPH, props)}
              icon={<IconFlipH fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.horizontal")}
            </MenuItem>
            <MenuItem
              onClick={() => transform(FLIPV, props)}
              icon={<IconFlipV fill="white" />}
              sx={menuStylesList}
            >
              {t("context_menu.vertical")}
            </MenuItem>
          </MenuList>
        </Menu>
      </MenuGroup>
    </Menu>
  );
};

const TldrContextMenu = (props) => {
  const { target, canvasRef, parentProps, signal } = props;

  return (target && target.id === "workarea") || !target ? (
    <PageMenu
      canvasRef={canvasRef}
      parentProps={parentProps}
      signal={signal}
    ></PageMenu>
  ) : (
    <LayerMenu
      target={target}
      canvasRef={canvasRef}
      parentProps={parentProps}
      signal={signal}
    ></LayerMenu>
  );
};

export default TldrContextMenu;
